var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dia, shapes, g } from '@joint/plus';
var WIDTH = 80;
var HEIGHT = 20;
var StencilNode = /** @class */ (function (_super) {
    __extends(StencilNode, _super);
    function StencilNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.PLUS_SIGN = 'M 1 5 9 5 M 5 1 5 9';
        _this.MINUS_SIGN = 'M 2 5 8 5';
        _this.markup = [{
                tagName: 'rect',
                selector: 'body',
            }, {
                tagName: 'text',
                selector: 'label'
            }, {
                tagName: 'image',
                selector: 'icon'
            }, {
                tagName: 'g',
                selector: 'buttonGroup',
                children: [{
                        tagName: 'rect',
                        selector: 'button'
                    }, {
                        tagName: 'path',
                        selector: 'buttonSign',
                        attributes: {
                            'fill': 'none',
                            'pointer-events': 'none'
                        }
                    }]
            }];
        return _this;
    }
    StencilNode.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: 'app.StencilNode', hidden: false, collapsed: false, matched: false, z: 2, size: {
                width: WIDTH,
                height: HEIGHT
            }, path: [], attrs: {
                root: {
                    cursor: 'move'
                },
                body: {
                    ref: 'label',
                    width: 'calc(w + 6)',
                    height: 'calc(h + 6)',
                    x: 'calc(x - 3)',
                    y: 'calc(y - 3)',
                    fill: 'transparent'
                },
                label: {
                    x: 25,
                    y: 'calc(0.5 * h)',
                    textVerticalAnchor: 'middle',
                    textAnchor: 'start',
                    fontSize: 13,
                    fontFamily: 'sans-serif'
                },
                icon: {
                    width: 20,
                    height: 20,
                },
                buttonGroup: {
                    transform: 'translate(-15, calc(0.5 * h))'
                },
                button: {
                    fill: '#FFFFFF',
                    stroke: '#808080',
                    x: -5,
                    y: -5,
                    height: 10,
                    width: 10,
                    cursor: 'pointer',
                    event: 'element:collapse',
                },
                buttonSign: {
                    transform: 'translate(-5, -5)',
                    stroke: '#808080',
                    strokeWidth: 1.6
                }
            } });
    };
    StencilNode.prototype.setIcon = function (icon) {
        return this.attr(['icon', 'xlinkHref'], icon);
    };
    StencilNode.prototype.isHidden = function () {
        return Boolean(this.get('hidden'));
    };
    StencilNode.prototype.isCollapsed = function () {
        return Boolean(this.get('collapsed'));
    };
    StencilNode.prototype.isMatched = function () {
        return Boolean(this.get('matched'));
    };
    StencilNode.prototype.isDirectory = function () {
        return Boolean(this.get('dir'));
    };
    StencilNode.prototype.toggleButtonVisibility = function (visible) {
        return this.attr('buttonGroup', { display: visible ? 'block' : 'none' });
    };
    StencilNode.prototype.toggleButtonSign = function (collapse) {
        return this.attr('buttonSign', { d: collapse ? this.MINUS_SIGN : this.PLUS_SIGN });
    };
    StencilNode.prototype.getPathString = function (separator) {
        if (separator === void 0) { separator = '/'; }
        return this.get('path').join(separator);
    };
    StencilNode.prototype.match = function (keyword) {
        // Set path value as label and annotate text
        var name = this.get('name');
        var displayName = this.getPathString(' / ');
        var annotations = [{
                // Bold Node Name
                start: 0,
                end: displayName.length - name.length,
                attrs: {
                    'fill': '#999'
                }
            }];
        var matchIndex = displayName.toLowerCase().lastIndexOf(keyword.toLowerCase());
        if (matchIndex > -1) {
            annotations.push({
                // Underlined Keyword
                start: matchIndex,
                end: matchIndex + keyword.length,
                attrs: {
                    'text-decoration': 'underline'
                }
            });
        }
        this.toggleButtonVisibility(false);
        this.prop({
            matched: true,
            attrs: {
                label: {
                    text: displayName,
                    annotations: annotations
                }
            }
        });
    };
    StencilNode.prototype.unmatch = function () {
        this.prop({
            matched: false,
            attrs: {
                label: {
                    text: this.get('name'),
                    annotations: null
                }
            }
        });
    };
    return StencilNode;
}(dia.Element));
export { StencilNode };
var StencilLink = /** @class */ (function (_super) {
    __extends(StencilLink, _super);
    function StencilLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.markup = [{
                tagName: 'path',
                selector: 'line',
                attributes: {
                    'fill': 'none',
                }
            }];
        return _this;
    }
    StencilLink.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: 'app.StencilLink', z: 1, router: function (_vertices, _opt, linkView) {
                var x = linkView.getEndAnchor('source').x;
                var y = linkView.getEndAnchor('target').y;
                return [new g.Point(x, y)];
            }, attrs: {
                root: {
                    pointerEvents: 'none'
                },
                line: {
                    connection: true,
                    stroke: '#C0C0C0',
                    strokeWidth: 1,
                    shapeRendering: 'optimizeSpeed',
                    vertexMarker: {
                        type: 'circle',
                        r: 1
                    }
                }
            } });
    };
    StencilLink.prototype.connect = function (parentId, childId) {
        this.set({
            source: {
                id: parentId,
                anchor: {
                    name: 'modelCenter',
                    args: {
                        dx: -(WIDTH / 2) + 5,
                        dy: HEIGHT / 2
                    }
                }
            },
            target: {
                id: childId,
                anchor: {
                    name: 'modelCenter',
                    args: { dx: -(WIDTH / 2) }
                }
            }
        });
    };
    StencilLink.prototype.isHidden = function () {
        // If the target element is collapsed, we don't want to
        // show the link either
        var targetElement = this.getTargetElement();
        return !targetElement || targetElement.isHidden();
    };
    return StencilLink;
}(dia.Link));
export { StencilLink };
export var cellNamespace = __assign(__assign({}, shapes), { app: {
        StencilNode: StencilNode,
        StencilLink: StencilLink
    } });
